import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";
import { brandHeart } from "../../constants/brandAssets";
import storiesBg from "./images/stories_bg.png";
import cpl1 from "./images/cpl1.jpg";
import cpl2 from "./images/cpl2.jpg";

const FALLBACK_STORIES = [
  {
    ss_id: 1,
    groom_name: "Karan Purohit",
    bride_name: "Preeti Pareek",
    groom_msg: "I am feeling very lucky for me to find my best match. I am thankful to Hindu Sanjog for helping me in search of my best match.",
    groom_image: "",
    bride_image: "",
  },
];

const WeddingSwiper = () => {
  const [loveStories, setLoveStories] = useState(FALLBACK_STORIES);
  const [loading, setLoading] = useState(false);

  const API_URL = `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/success-story.php`;
  const IMAGE_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios
      .get(API_URL)
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          setLoveStories(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching love stories!", error);
        setLoading(false);
      });
  }, [API_URL]);

  const stories = loveStories && loveStories.length > 0 ? loveStories : FALLBACK_STORIES;

  return (
    <section className="wedding-story-section">
      <div className="wedding-swiper-container">
        <h3 className="heading text-center">
          From Strangers to Soulmates – <span style={{ color: "#E53D5C" }}>Real Love Stories!</span>
        </h3>

        {loading ? (
          <p style={{ textAlign: "center" }}>Loading stories...</p>
        ) : (
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            loop={stories.length > 1}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            navigation
            className="wedding-swiper-wrapper"
          >
            {stories.map((story, index) => (
              <SwiperSlide key={story.ss_id || index} className="wedding-swiper-slide">
                <div className="wedding-slide-content">
                  <div className="wedding-image-container">
                    <img
                      alt={story.groom_name}
                      className="wedding-profile-image"
                      src={story.groom_image ? `${IMAGE_BASE_URL}${story.groom_image}` : cpl1}
                      onError={(e) => {
                        e.target.src = cpl1;
                        e.target.onerror = null;
                      }}
                    />
                    <div className="wedding-heart-icon-container">
                      <img
                        alt="Heart"
                        className="wedding-heart-icon"
                        src={brandHeart}
                      />
                    </div>
                    <img
                      alt={story.bride_name}
                      className="wedding-profile-image"
                      src={story.bride_image ? `${IMAGE_BASE_URL}${story.bride_image}` : cpl2}
                      onError={(e) => {
                        e.target.src = cpl2;
                        e.target.onerror = null;
                      }}
                    />
                  </div>

                  <p className="wedding-testimonial-text">{story.groom_msg}</p>
                  <p className="wedding-couple-names">
                    {story.groom_name} &amp; {story.bride_name}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>

      <style>{`
        .wedding-story-section {
          position: relative;
          padding: 65px 0 55px;
          background-color: #faf6f4;
          overflow: hidden;
          isolation: isolate;
        }

        .wedding-story-section::before {
          content: "";
          position: absolute;
          top: -8px;
          left: -8px;
          right: -8px;
          bottom: -8px;
          background-image: url(${storiesBg});
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          filter: blur(2.5px);
          -webkit-filter: blur(2.5px);
          transform: scale(1.02);
          z-index: 0;
        }

        .wedding-story-section::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(255, 255, 255, 0.08);
          z-index: 1;
          pointer-events: none;
        }

        .wedding-swiper-container {
          max-width: 900px;
          margin: 0 auto;
          padding: 0 20px;
          position: relative;
          z-index: 2;
        }

        .heading {
          margin-bottom: 30px;
          font-weight: 700;
        }

        .wedding-slide-content {
          text-align: center;
        }

        .wedding-image-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          margin-bottom: 20px;
        }

        .wedding-profile-image {
          width: 120px;
          height: 120px;
          object-fit: cover;
          border-radius: 50%;
          border: 4px solid white;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
        }

        .wedding-heart-icon-container {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: white;
          border: 4px solid #E53D5C;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 14px rgba(229, 61, 92, 0.15);
        }

        .wedding-heart-icon {
          width: 40px;
          height: 40px;
        }

        .wedding-testimonial-text {
          font-size: 1.1rem;
          font-weight: 600;
          max-width: 540px;
          margin: 0 auto 10px;
          line-height: 1.6;
          color: #2b2b2b;
        }

        .wedding-couple-names {
          font-size: 1.05rem;
          color: #E53D5C;
          font-weight: 700;
        }

        .swiper-button-prev,
        .swiper-button-next {
          color: #E53D5C;
          width: 40px;
          height: 40px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }

        .swiper-button-prev:hover,
        .swiper-button-next:hover {
          background: #E53D5C;
          color: white;
        }

        .swiper-pagination-bullet {
          background: #ccc;
        }

        .swiper-pagination-bullet-active {
          background: #E53D5C;
        }

        @media (max-width: 768px) {
          .wedding-story-section {
            padding: 40px 0 30px;
          }

          .wedding-profile-image {
            width: 95px;
            height: 95px;
          }

          .wedding-heart-icon-container {
            width: 50px;
            height: 50px;
          }

          .wedding-heart-icon {
            width: 30px;
            height: 30px;
          }
        }
      `}</style>
    </section>
  );
};

export default WeddingSwiper;
